import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import DataOffers from "@/data/AdminPanel/DataOffers";
import ApiEnter from "@/api/ApiEnter";
import ApiOffer from "@/api/ApiOffer";
import sweetalert from "sweetalert";
import ApiAdmin from "@/api/ApiAdmin";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditor from "@/data/CKeditor/config";
import { EAdminPanelOffersPriceFor, EOffersColor } from "@/struct/admin-panel/EAdminPanelOffersPriceFor";
let OfferCreate = class OfferCreate extends Vue {
    constructor() {
        super(...arguments);
        this.editor = ClassicEditor;
        this.editorConfig = CKEditor.editorConfig(ApiEnter.CurrentSessionUUID);
        this.editorShortConfig = CKEditor.editorOffersShort();
        this.Breadcrumbs = DataOffers.OfferCreateBreadcrumbs;
        this.NewCategoryCardDesign = ["Blue", "Orange", "Transparent"];
        this.OffersCategories = [];
        this.ActiveOffers = []; // TODO: Уточнить почему жалуется на never
        this.ActiveOfferID = 0;
        this.ActiveOffer = null;
        this.colorItems = [
            {
                text: "light gray",
                value: EOffersColor.LightGray,
            },
            {
                text: "light red",
                value: EOffersColor.LightRed,
            },
            {
                text: "light blue",
                value: EOffersColor.LightBlue,
            },
        ];
        this.newOfferCustomisation = {
            free: {
                value: true,
                color: EOffersColor.LightGray,
                bold: false,
            },
            rates_abroad: {
                value: true,
                color: EOffersColor.LightGray,
                bold: false,
            },
            additional_data: {
                value: "",
                color: EOffersColor.LightGray,
                bold: false,
            },
            additional_data_two: {
                value: "",
                color: EOffersColor.LightGray,
                bold: false,
            },
            additional_data_three: {
                value: "",
                color: EOffersColor.LightGray,
                bold: false,
            },
            int_minutes: {
                value: "",
                color: EOffersColor.LightGray,
                bold: false,
            },
        };
        this.newOffer = {
            name: "",
            priority: "",
            publish: true,
            category: [],
            price: "",
            data: "",
            data_eu: "",
            sms: "",
            min: "",
            additional_data: "",
            int_min: "",
            countries: "",
            activation_info: "",
            display_roaming: true,
            overview: "",
            note: "",
            design: "",
            photo_list: null,
            alt_list: "",
            photo_slide_lg: null,
            alt_slide_lg: "",
            photo_slide: null,
            alt_slide: "",
            photo_slide_m: null,
            alt_slide_m: "",
            display_offers: false,
            display_home: false,
            display_slider: false,
            landing_only: false,
            no_index: false,
            active: "active",
            tariff_overview: "",
            prospects_info: null,
            contract: null,
            title: "",
            description: "",
            keywords: "",
            url: "",
            price_for: EAdminPanelOffersPriceFor.AlMese,
            other_text: "",
        };
        this.HasLoading = false;
        this.LoadingDataFromBSS = true;
        this.priceForEnum = EAdminPanelOffersPriceFor;
        this.priceForItems = [
            {
                text: "al mese",
                value: EAdminPanelOffersPriceFor.AlMese,
            },
            {
                text: "1° mese",
                value: EAdminPanelOffersPriceFor.OneMese,
            },
            {
                text: "con 2 mesi inclusi",
                value: EAdminPanelOffersPriceFor.ConTwoMesiInclusi,
            },
            {
                text: "con 3 mesi inclusi",
                value: EAdminPanelOffersPriceFor.ConThreeMesiInclusi,
            },
            {
                text: "other",
                value: EAdminPanelOffersPriceFor.Other,
            },
        ];
    }
    Translit(str) {
        let ru = "А-а-Б-б-В-в-Ґ-ґ-Г-г-Д-д-Е-е-Ё-ё-Є-є-Ж-ж-З-з-И-и-І-і-Ї-ї-Й-й-К-к-Л-л-М-м-Н-н-О-о-П-п-Р-р-С-с-Т-т-У-у-Ф-ф-Х-х-Ц-ц-Ч-ч-Ш-ш-Щ-щ-Ъ-ъ-Ы-ы-Ь-ь-Э-э-Ю-ю-Я-я".split("-");
        let en = "A-a-B-b-V-v-G-g-G-g-D-d-E-e-E-e-E-e-ZH-zh-Z-z-I-i-I-i-I-i-J-j-K-k-L-l-M-m-N-n-O-o-P-p-R-r-S-s-T-t-U-u-F-f-H-h-TS-ts-CH-ch-SH-sh-SCH-sch-'-'-Y-y-'-'-E-e-YU-yu-YA-ya".split("-");
        let res = "";
        for (let i = 0, l = str.length; i < l; i++) {
            let s = str.charAt(i), n = ru.indexOf(s);
            if (n >= 0) {
                res += en[n];
            }
            else {
                res += s;
            }
        }
        return res;
    }
    GenerateSeoUrl() {
        let url = this.Translit(this.newOffer.name.replace(/[\s]+/gi, "-"));
        this.newOffer.url = url.replace(/[^0-9a-z_-]+/gi, "").toLowerCase();
        // this.newOffer.url = this.newOffer.name.replace(/[. ,:-=&+#$?|%@!^(){}'*]+/g, "-").toLowerCase()
    }
    ValidateSeoUrl() {
        this.newOffer.url = this.Translit(this.newOffer.url.replace(/[. ,$@!^()'*]+/g, "-").toLowerCase());
        // this.newOffer.url = this.newOffer.url.replace(/[. ,$@!^()'*]+/g, '-').toLowerCase()
    }
    async getOffersCategories() {
        try {
            this.OffersCategories = await ApiOffer.GetOfferCategories(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            const activeOffer = this.ActiveOfferID ? JSON.stringify(this.ActiveOffer) : "";
            const additionalDataStyle = {
                color: this.newOfferCustomisation.additional_data.color,
                bold: this.newOfferCustomisation.additional_data.bold,
            };
            const additionalDataTwoStyle = {
                color: this.newOfferCustomisation.additional_data_two.color,
                bold: this.newOfferCustomisation.additional_data_two.bold,
            };
            const additionalDataThreeStyle = {
                color: this.newOfferCustomisation.additional_data_three.color,
                bold: this.newOfferCustomisation.additional_data_three.bold,
            };
            const freeStyle = {
                color: this.newOfferCustomisation.free.color,
                bold: this.newOfferCustomisation.free.bold,
            };
            const ratesAbroadStyle = {
                color: this.newOfferCustomisation.rates_abroad.color,
                bold: this.newOfferCustomisation.rates_abroad.bold,
            };
            const intMinutesStyle = {
                color: this.newOfferCustomisation.int_minutes.color,
                bold: this.newOfferCustomisation.int_minutes.bold,
            };
            const offer_uuid = await ApiOffer.CreateOffer(ApiEnter.CurrentSessionUUID, this.newOffer.name, this.newOffer.priority, this.newOffer.publish ? 1 : 0, this.newOffer.category.join(), this.newOffer.price, this.newOffer.data, this.newOffer.data_eu, this.newOffer.sms, this.newOffer.min, this.newOfferCustomisation.additional_data.value, this.newOfferCustomisation.int_minutes.value, this.newOffer.countries, this.newOfferCustomisation.rates_abroad.value ? 1 : 0, this.newOfferCustomisation.free.value ? 1 : 0, this.newOffer.activation_info, this.newOffer.display_roaming ? 1 : 0, this.newOffer.overview, this.newOffer.note, this.newOffer.design, this.newOffer.photo_list != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.photo_list)) : "", this.newOffer.alt_list, this.newOffer.photo_slide != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.photo_slide)) : "", this.newOffer.alt_slide, this.newOffer.photo_slide_lg != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.photo_slide_lg)) : "", this.newOffer.alt_slide_lg, this.newOffer.photo_slide_m != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.photo_slide_m)) : "", this.newOffer.alt_slide_m, this.newOffer.display_offers ? 1 : 0, this.newOffer.display_home ? 1 : 0, this.newOffer.display_slider ? 1 : 0, this.newOffer.landing_only ? 1 : 0, this.newOffer.no_index ? 1 : 0, this.newOffer.active === "active" ? 1 : 0, this.newOffer.tariff_overview, this.newOffer.prospects_info != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.prospects_info)) : "", this.newOffer.contract != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.contract)) : "", this.newOffer.title, this.newOffer.description, this.newOffer.keywords, this.newOffer.url, activeOffer, this.ActiveOfferID, this.newOffer.other_text, this.newOffer.price_for, JSON.stringify(additionalDataStyle), this.newOfferCustomisation.additional_data_two.value, JSON.stringify(additionalDataTwoStyle), this.newOfferCustomisation.additional_data_three.value, JSON.stringify(additionalDataThreeStyle), JSON.stringify(freeStyle), JSON.stringify(ratesAbroadStyle), JSON.stringify(intMinutesStyle));
            if (offer_uuid == undefined || offer_uuid.length != 36) {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
                return;
            }
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success",
            }).then(() => {
                this.$forceUpdate();
                this.$router.push(`/shop/offers`);
            });
        }
        this.HasLoading = false;
    }
    async GetActiveOffers() {
        const response = await ApiOffer.GetActiveOffers(ApiEnter.CurrentSessionUUID);
        if (typeof response != "boolean") {
            this.ActiveOffers = response;
            this.ActiveOffers.unshift({
                ID: null,
                Title: "No matching",
            });
        }
        else {
            sweetalert({
                title: this.$t("general.error"),
                text: "Error to get offers from BSS",
                icon: "info",
            });
        }
        this.LoadingDataFromBSS = false;
    }
    ChangeActiveOffer() {
        this.ActiveOffer = this.ActiveOffers.find(item => item.ID == this.ActiveOfferID);
    }
    OnChangeLandingOnly(value) {
        if (value) {
            this.newOffer.display_offers = false;
            this.newOffer.display_home = false;
            this.newOffer.display_slider = false;
        }
    }
    async mounted() {
        await this.getOffersCategories();
        await this.GetActiveOffers();
    }
};
OfferCreate = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], OfferCreate);
export default OfferCreate;
